import { defineMessages } from 'react-intl'

export default defineMessages({
  howitworks_1_heading: {
    id: 'howitworks_1_heading',
    defaultMessage: 'Pick your diet plan',
  },
  howitworks_1_text: {
    id: 'howitworks_1_text',
    defaultMessage:
      'From Low Carb to Keto Diet, High Protein and everything in between, we’ve got what you need. Buon appetito!',
  },
  howitworks_2_heading: {
    id: 'howitworks_2_heading',
    defaultMessage: 'Track your habits',
  },
  howitworks_2_text: {
    id: 'howitworks_2_text',
    defaultMessage:
      'Log your meals and workouts to track your progress. We’ve made things fast and easy with a huge library of foods.',
  },
  howitworks_3_heading: {
    id: 'howitworks_3_heading',
    defaultMessage: 'Get the feedback you need',
  },
  howitworks_3_text: {
    id: 'howitworks_3_text',
    defaultMessage:
      'We’ll keep you on track and in the right mindset with daily feedback, suggestions and the occasional motivational cheer.',
  },
})
